import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import fetchLastVehicles from '../../../services/vehicles/last-entries';
import { getLastVehiclesKey } from '../query-keys';

const getLastVehicles = (
  options: {
    locale: string;
    part?: string;
    vehicle?: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchLastVehicles>
] => [
  getLastVehiclesKey(options),
  ({ queryKey: [, locale, part, vehicle] }: { queryKey: string[] }) =>
    fetchLastVehicles(
      {
        locale,
        ...(part && { partIdentifier: part }),
        ...(vehicle && { carIdentifier: vehicle }),
      },
      req
    ),
];

export default getLastVehicles;
